import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Grid, Paper, useTheme } from '@mui/material';
import NoteCard from '../../NoteCard';

const NotesCorkboardView = ({ notes, onNoteSelect }) => {
  const theme = useTheme();

  const handleNoteClick = (note) => {
    if (onNoteSelect) {
      onNoteSelect(note);
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
        overflow: 'auto',
        p: 3,
        backgroundImage:
          'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(0,0,0,0.02) 10px, rgba(0,0,0,0.02) 20px)',
        backgroundColor:
          theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.3)' : 'rgba(200,180,150,0.1)',
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Corkboard View
      </Typography>

      {notes.length > 0 ? (
        <Grid container spacing={2}>
          {notes.map((note, index) => {
            // Add slight rotation for a "pinned" effect
            const rotation = ((index % 3) - 1) * 2; // -2, 0, or 2 degrees
            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={note._id || note.id || note.noteId}>
                <Paper
                  elevation={3}
                  sx={{
                    transform: `rotate(${rotation}deg)`,
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: `rotate(${rotation}deg) scale(1.05)`,
                      zIndex: 1,
                      position: 'relative',
                    },
                    cursor: 'pointer',
                  }}
                  onClick={() => handleNoteClick(note)}
                >
                  <Box sx={{ p: 2 }}>
                    <NoteCard note={note} onClick={handleNoteClick} />
                  </Box>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: 'text.secondary',
            gap: 2,
            minHeight: '50vh',
          }}
        >
          <Typography variant="h6">No notes yet</Typography>
          <Typography variant="body2">Create a note to start organizing your ideas.</Typography>
        </Box>
      )}
    </Box>
  );
};

NotesCorkboardView.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onNoteSelect: PropTypes.func,
};

NotesCorkboardView.defaultProps = {
  onNoteSelect: null,
};

export default NotesCorkboardView;
